module.exports = __webpack_public_path__ + "img/23.00b77c6a.jpg";